<template>
  <div ref="tradedistribution"
       class="pbr-index-chart">
       <Empty></Empty>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import Mixin from '../mixin'
import {chartColors} from '../../../analysis/constant'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartTradeDistribution',
  mixins: [Mixin],
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    height: {
      type: Number
    }
    },
  inject: ['chartDatas'],
  data () {
    return {
      tradeDistributionChart: null,
      optionTradedistribution: null,
      isResize: false,
    }
  },
  computed: {
    chartData () {
      const projectChartData = this.chartDatas.projectChartData()
      // return projectChartData === {} ? [{name: '', num: 0, percentage: 0}] : projectChartData.projectIndustryChart
      if (projectChartData.hasOwnProperty('projectIndustryChart') && projectChartData.projectIndustryChart.length > 0) {
        return projectChartData.projectIndustryChart
      }
      return [{name: '', num: 0, percentage: 0}]
    }
  },
  methods: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    },
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.tradedistribution){
        return
      }
      if (this.tradeDistributionChart) {
        this.tradeDistributionChart.dispose()
      }
      let countContrastDom = this.$refs.tradedistribution
      this.tradeDistributionChart = echarts.init(countContrastDom, theme, {devicePixelRatio: 2.5,height: this.height})
      this.tradeDistributionChart.setOption(this.optionTradedistribution)

      // this.tradeDistributionChart.resize({height})
      this.tradeDistributionChart.on('click', function (param) {
        // self.$emit('trade-distribution-chart-click', param)
        self.dispatch('pbrIndex', 'filterData', {module: 'xm', condition: {type: 'industry', title: param.data.name, id: param.data.id}})
      })

      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.tradeDistributionChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      let self = this
      this.optionTradedistribution = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: this.$t('charts.home.project.industryDistribution'),
          left: 'center',
          top:0
        },
        dataset: {
          dimensions: ['name', 'num', 'percentage'],
          source: this.chartData
        },
        tooltip: {
          trigger: 'item',
          confine:true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        legend: {
          type:'scroll',
          orient: 'horizontal',
          top: this.showTitle ? 26 : 0,
          itemWidth:10,
          itemHeight:10,
          textStyle: {
            color: self.isDark() ?  '#ebedee' : '#101010'
          },
          tooltip: {
            show: true,
            // position: ['50%', '50%'],
            // position: function (p) { // 其中p为当前鼠标的位置
            //   return [p[0] + 10, p[1] - 10]
            // },
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
          },
        },
        series: [
          {
            name: this.$t('charts.home.project.industryDistribution'),
            type: 'pie',
            radius: '100%',
            top: this.showTitle ? 56 : 30,
            bottom:10,
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            label: {
            //   show: false,
              normal: {
                formatter: '{@percentage}',
                position: 'inside',
                fontSize: 8,
                color: '#fff',
                align: 'left',
                verticalAlign: 'top'
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '8',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
          }
        ]
      }
    },
    resize () {
      this.isResize = true
      this.tradeDistributionChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  activated () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue && newValue.length === 0) {
          if (this.tradeDistributionChart) {
            this.tradeDistributionChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
